import LabDetail from '../labDetail';
import OwnerDetail from '../ownerDetail';
import StoreDetail from '../storeDetail';

const SelectStep = ({
  mode,
  type,
  touched,
  mutateFn,
  setTouched,
  currentStep,
  setCurrentStep,
  profileData,
  setIsSuccessModal,
  isLoadingMutattion,
}: ISteps): JSX.Element => {
  const selectStep: Record<string, JSX.Element> = {
    2: (
      <OwnerDetail
        setCurrentStep={setCurrentStep}
        setTouched={setTouched}
        touched={touched}
        profileData={profileData}
        mode={mode}
      />
    ),
    3: (
      <StoreDetail
        setCurrentStep={setCurrentStep}
        setTouched={setTouched}
        touched={touched}
        mode={mode}
        type={type}
        mutateFn={mutateFn}
        isLoadingMutattion={isLoadingMutattion}
      />
    ),
    4: (
      <LabDetail
        setCurrentStep={setCurrentStep}
        setTouched={setTouched}
        touched={touched}
        setIsSuccessModal={setIsSuccessModal}
        mutateFn={mutateFn}
        mode={mode}
        type={type}
        isLoadingMutattion={isLoadingMutattion}
      />
    ),
  };

  return selectStep[currentStep];
};

export default SelectStep;
